import React, {useEffect, useState} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { checkToken, checkClientToken } from "./utils/common";
import Loader from "./pages/Loader"
import Layout from "./components/common/Layout";


const Login = React.lazy(() => import("./pages/Login"));
const Register = React.lazy(() => import("./pages/Register"));
const ForgetPassword = React.lazy(() => import("./pages/ForgetPassword"));

const ClientLogin = React.lazy(() => import("./pages/ClientLogin"));
const ClientHome = React.lazy(() => import("./pages/ClientHome"));
const ClientQR = React.lazy(() => import("./pages/ClientQR"));
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const VM = React.lazy(() => import("./pages/VM"));
const User = React.lazy(() => import("./pages/User"));
const Merchant = React.lazy(() => import("./pages/Merchant"));
const Device = React.lazy(() => import("./pages/Device"));
const UserDevice = React.lazy(() => import("./pages/UserDevice"));
const TestPage = React.lazy(() => import("./pages/TestPage"));
const AdminTicket = React.lazy(() => import("./pages/AdminTicket"));
const MonthlyReport = React.lazy(() => import("./pages/MonthlyReport"));
const Payment = React.lazy(() => import("./pages/Payment"));



const Cluster = React.lazy(() => import("./pages/Cluster"));
const Notifications = React.lazy(() => import("./pages/Notifications"));
const UserActions = React.lazy(() => import("./pages/UserActions"));
const HealthCheck = React.lazy(() => import("./pages/HealthCheck"));
const ServerError = React.lazy(() => import("./pages/ServerError"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const UserMetaProfileMgt = React.lazy(() => import("./pages/UserMetaProfileMgt"));

const TicketAccess = React.lazy(() => import("./pages/TicketAccess"));
const TicketAuth = React.lazy(() => import("./pages/TicketAuth"));
const QRScanPage = React.lazy(() => import("./pages/QRScanPage"));
const MerchantScannerLoginPage = React.lazy(() => import("./pages/MerchantScannerLoginPage"));




const ProjectRoutes = () => {

  const isLoggedIn = checkToken();
  const isClientLoggedIn = checkClientToken();


  return (
    <React.Suspense fallback={<Loader />}>
      <Router>
        <RouteLoader></RouteLoader>
        <Routes>

          <Route path="/login" element={isLoggedIn ? <Navigate to="/" replace /> : <Login />} />
		  <Route path="/register" element={<Register />} />
		  <Route path="/forgetpassword" element={<ForgetPassword />} />


		  {/* Authenticated routes — shared Layout wrapper */}
          <Route element={isLoggedIn ? <Layout /> : <Navigate to="/login" replace />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/usermetaprofilemgt" element={<UserMetaProfileMgt />} />

            <Route path="/user" element={<User />} />
            <Route path="/user/create" element={<User />} />
            <Route path="/user/update/:searchUserId" element={<User />} />
            <Route path="/userdevice/:searchUserId" element={<UserDevice />} />

		  {  /*
            <Route path="/couponuser" element={<User />} />
            <Route path="/couponuser/create" element={<User />} />
            <Route path="/couponuser/update/:searchUserId" element={<User />} />
            <Route path="/couponuserdevice/:searchUserId" element={<UserDevice />} />
		  */
		  }

            <Route path="/merchant" element={<Merchant />} />
            <Route path="/merchant/create" element={<Merchant />} />
            <Route path="/merchant/update/:searchMerchantId" element={<Merchant />} />
            <Route path="/merchant/updatemsgsvr/:searchMerchantId" element={<Merchant />} />

            <Route path="/device" element={<Device />} />
            <Route path="/device/create" element={<Device />} />
            <Route path="/device/update/:deviceId" element={<Device />} />

		  <Route path="/event" element={<Device />} />

            <Route path="/couponevent" element={<Device />} />
            <Route path="/couponevent/create" element={<Device />} />
            <Route path="/couponevent/update/:deviceId" element={<Device />} />

            <Route path="/testpage" element={<TestPage />} />

            <Route path="/ticket" element={<AdminTicket />} />
            <Route path="/normalticket" element={<AdminTicket />} />
            <Route path="/citypassticket" element={<AdminTicket />} />
		  <Route path="/citypassticketevents/:orderEmail" element={<AdminTicket />} />

            <Route path="/monthlyreport" element={<MonthlyReport />} />
            <Route path="/dailyreport" element={<MonthlyReport />} />

            <Route path="/payment" element={<Payment />} />
            <Route path="/payment/history" element={<Payment />} />
            <Route path="/payment/payment_success" element={<Payment />} />
		  <Route path="/payment/payment_fail" element={<Payment />} />
            <Route path="/payment/payment_merchant_list" element={<Payment />} />
            <Route path="/payment/payment_email_template" element={<Payment />} />

            <Route path="/vm" element={<VM />} />
            <Route path="/vm/create" element={<VM />} />
            <Route path="/vm/update/:vmId" element={<VM />} />

            <Route path="/cluster" element={<Cluster />} />
            <Route path="/cluster/create" element={<Cluster />} />
            <Route path="/cluster/update/:clusterId" element={<Cluster />} />

            <Route path="/notifications" element={<Notifications />} />
            <Route path="/user-activity" element={<UserActions />} />
          </Route>

          <Route path="/healthcheck" element={<HealthCheck />} />

		  <Route path="/clientlogin" element={<ClientLogin />} />
		  <Route
            path="/clienthome"
            element={isClientLoggedIn ? <ClientHome /> : <Navigate to="/clientlogin" replace />}
          />
		  <Route
            path="/clientqr"
            element={isClientLoggedIn ? <ClientQR /> : <Navigate to="/clientlogin" replace />}
          />


		  <Route path="/ticketAuth" element={<TicketAuth />} />
		  <Route path="/ticketAccess" element={<TicketAccess />} />


		  <Route path="/qrScanPage" element={<QRScanPage />} />
		  <Route path="/merchantScannerLogin" element={<MerchantScannerLoginPage />} />

          <Route path="/500" element={<ServerError />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </React.Suspense>
  );
};

export default ProjectRoutes;


const RouteLoader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
    }, 300);

    return () => clearTimeout(loadingTimeout);
  }, []);

  return isLoading && (
    <Loader></Loader>
  )
};
